import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import API from '@/common/API.js'
import LANG from '@/common/lang.js'
import Analytics from '@/common/analytics.js';
import Translation from '@/common/filter/translation.js'

//Google
// import VueGtm from 'vue-gtm';
import VueHead from 'vue-head'

Vue.config.productionTip = false
Vue.prototype.$LANG = LANG;
Vue.use(VueHead);
Vue.use(Analytics);
console.log('iSTAY guest review VERSION.' + process.env.VUE_APP_VERSION)

new Vue({
  created() {
    try {
      
      window.dataLayer = window.dataLayer || [];
      this.$store.dispatch('userCheck', {}).then(res=>{
        const urlSiteid = new URLSearchParams(document.location.search).get('siteid');
        if(res && res.siteid){
          if(urlSiteid && urlSiteid !== res.siteid){
            router.push({ name: 'Error' });
            return;
          }
          Analytics.gtag('js', new Date());
          Analytics.gtag('config', 'UA-156911706-4', 
            {
              'page_title' : 'site review',
              'page_path': `/index.html?t=site&k=${res.k}&siteid=${res.siteid}` 
            }
          );
        } else if(res && !res.siteid){
          router.push({ name: 'Error' });
        }
      });

    } catch (error) {
      router.push({ name: 'Error' });
    }
  },
  head: {
    title: {
      inner: 'REVIEW'
    },
    meta: [
      {name: 'viewport', content: 'width=device-width, initial-scale=1, maximum-scale=1, user-scalable=0'}
    ],
    script: [
      { type: 'text/javascript', src: 'https://www.googletagmanager.com/gtag/js?id=UA-156911706-4', async: true, body: true}, // Insert in body
    ]
   },
  router,
  store,
  render: h => h(App)
}).$mount('#app')
require('@/styles/common.scss');

